const menus = [
    {
        id: 1,
        name: '首页',
        links: '/home'
    },
    {
        id: 2,
        name: '关于我们',
        links: '/AboutUs'
    },
    {
        id: 3,
        name: '德联商城',
        links: '/Mall'
    },
    {
        id: 4,
        name: '入驻德联',
        links: '/JoinUs',
    },
    {
        id: 5,
        name: '德联服务',
        links: '',
        namesub: [
            {
                id: 1,
                sub: '产品供应链',
                links: '/Mall'
            },
            //{
            //    id: 2,
            //    sub: '金融支持服务',
            //    links: '/FinancialService'
            //},
            {
                id: 3,
                sub: 'IT 服务',
                links: '/ITService'
            },
            {
                id: 4,
                sub: '增值服务',
                links: '/IncrementService'
            }
        ],
    },    
    {
        id: 6,
        name: '我的德联',
        links: '',
        namesub: [
            {
                id: 211,
                sub: '我的订单',
                links: '/MyDelian'
            },
            {
                id: 212,
                sub: '发票管理',
                links: '/InvoiceManagement'
            },
            {
                id: 221,
                sub: '我的积分',
                links: '/MyPoint'
            },
            {
                id: 231,
                sub: '联系人管理',
                links: '/ContactManagement'
            },
            {
                id: 232,
                sub: '地址管理',
                links: '/AddressManagement'
            },
            {
                id: 400,
                sub: '退出',
                links: '/home'
            }
        ],
    }
]

export default menus;